import React from "react";
import ListVoting from "./ListVoting";
//import Sponsors from './Sponsors'
import InfoRule from "./InfoRule";

const MainSection = () => (
  <main className="relative z-10 flex-1 mx-auto">
    <div className="mx-auto">
      {/* Thời gian bình chọn và thể lệ */}
      <InfoRule />
      {/* nhà tài trợ */}
      {/* <Sponsors /> */}
      {/* Giải thưởng */}
      {/* <Rewards /> */}
      {/* Danh sách bình chọn */}
      {process.env.REACT_APP_PAGE_DEVELOP_MODE ? (
        <div className="h-[15vw]"></div>
      ) : (
        <ListVoting />
      )}
    </div>
  </main>
);

export default MainSection;
